function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M12,14.9383422 L19.719699,7.21964518 C20.0126059,6.92676562 20.4874796,6.92678777 20.7803592,7.21969465 C21.0732387,7.51260153 21.0732166,7.98747526 20.7803097,8.28035482 L13.0607123,15.9989519 C12.4757342,16.5847646 11.5266219,16.5854407 10.9408019,16.0004618 L3.21969465,8.28035482 C2.92678777,7.98747527 2.92676562,7.51260153 3.21964518,7.21969465 C3.51252473,6.92678777 3.98739847,6.92676562 4.28030535,7.21964518 L12,14.9383422 Z",
  transform: "rotate(-90 12 11.72)",
  fillRule: "evenodd"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
};

export default __webpack_public_path__ + "media/angle-right-mid.svg";
export { SvgComponent as ReactComponent };